<template>
  <div class="wrapper-full nibut">
    <el-container>
      <el-main :style="`height:${dispH - 350}px;weight:${dispW - 500}px;`" class="border-normal">
        <ImageBox
          :src="getImageURL(dispPhoto)"
          :width="dispW - 500"
          :height="dispH - 355"
          :focus="true"
          :colorHex="graphColor"
          :marking="getMarking()"
          :proc="getProc()"
          :eyetype="getEyeType()"
          :currentUnit="graphUnit"
          :currentPhoto="dispPhoto"
          :curPage="currPage"
          @update="update"
          @focus="onImageFocus"
          @paper="selectPaper"
          :graphMode="graphMode"
        />
      </el-main>
      <el-aside
        width="500px"
        :style="`display:flex;flex-direction:column;align-items:center;justify-content:center;padding-top:5px;padding-bottom:5px;padding-right:5px`"
      >
        <div class="aside-container" :style="`width:495px;height:${dispH - 355}px;`">
          <ImageList :photos="photos" @changeShowItem="changeShowItem" :dispH="300" />
        </div>
      </el-aside>
    </el-container>
    <div class="df aic jcb" style="font-size: 30px; padding-left: 20px; padding-right: 20px">
      <div class="df fdc" style="margin-right: 20px">
        <span style="margin-bottom: 20px"
          >{{ $t("langcfg.txtLimbalBloodVessel") }} {{ $t("langcfg.txtProportionAnalysis") }}</span
        >
        <span style="margin-bottom: 20px">{{ $t("langcfg.txtNasal") }}: {{ cillaryN }}</span>
        <span>{{ $t("langcfg.txtTemporal") }}: {{ cillaryT }}</span>
      </div>
      <div class="df fdc" style="margin-right: 20px">
        <span style="margin-bottom: 20px"
          >{{ $t("langcfg.txtBulbarConjunctivalVascular") }}
          {{ $t("langcfg.txtProportionAnalysis") }}</span
        >
        <span style="margin-bottom: 20px">{{ $t("langcfg.txtNasal") }}: {{ conjunctivalN }}</span>
        <span>{{ $t("langcfg.txtTemporal") }}: {{ conjunctivalT }}</span>
      </div>
      <div class="df">
        <span>{{ $t("langcfg.txtRemarks") }}：</span>
        <span>
          <el-input
            v-model="note"
            style="width: 300px"
            resize="none"
            :row="4"
            @change="changeNote"
            @click.native.stop.prevent="handleClick"
            @touchend.native.stop.prevent="handleClick"
            type="textarea"
          />
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import { Size, SubPageSize } from "../../mixins";
import TrendChart from "./basic/TrendChart";
import ImageBox from "../../common/components/ImageBox";
import ImageItem from "./basic/ImageItem";
import ImageList from "./basic/ImageList";
import EVENTS from "../../bus";
import { cloneObj, getImageUrl } from "../../shared/utils";
let img1px = new Image();
img1px.onload = () => {};
function handleValue(val) {
  if (val === undefined || val === "") {
    return "--";
  } else if (val === -1 || val === -1000) {
    return "--";
  } else {
    return Math.floor(val * 1000) / 10 + "%";
  }
}
export default {
  name: "EyeRedness",
  mixins: [Size, SubPageSize],
  data() {
    return {
      zoom: 1.5,
      isHugeMapVisible: false,
      currentid: 0,
      src: "",
      trendData: [
        [0, 0.1],
        [2, 0.3],
        [4, 0.15],
        [6, 0.5],
        [8, 0.2],
        [10, 0.18],
        [12, 0.1]
      ],
      cillaryN: "18.5%",
      cillaryT: "18.5%",
      conjunctivalN: "18.5%",
      conjunctivalT: "18.5%",
      result: "",
      graphColor: "#00ff00",
      graphUnit: "mm",
      dispPhoto: {},
      currPage: "eyeredness",
      graphMode: "Select",
      needUserfulData: {},
      photos: [],
      osodStatus: "OD",
      curRecord: {},
      note: "",
      isShowkeyboard: false,
      showInfo: "0px"
    };
  },
  props: {
    record: Object,
    currentEye: {
      type: String,
      default: "OS"
    }
  },
  mounted() {
    this.init(this.record);
    this.$bus.$emit(EVENTS.uploadingThirdyParty, "eyeredness");
  },
  components: {
    TrendChart,
    ImageItem,
    ImageList,
    ImageBox
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
    },
    init(record) {
      this.curRecord = cloneObj(record);

      this.needUserfulData[this.currentEye] =
        this.curRecord.content[`data${this.currentEye}`]["eyeredness"];
      this.showInterFaceOrToCamer();
    },
    showInterFaceOrToCamer() {
      this.photos = new Array(4);

      let recordPhotos = this.needUserfulData[this.currentEye].photos.filter((e) => {
        return e && e.imagelabel !== "";
      });

      if (recordPhotos.length === 1) {
        this.photos.splice(0, 1, recordPhotos[0]);
      } else {
        for (let id in recordPhotos) {
          if (recordPhotos[id].imagelabel === "original") {
            this.photos.splice(0, 1, recordPhotos[id]);
          } else if (recordPhotos[id].imagelabel === "enhance") {
            this.photos.splice(1, 1, recordPhotos[id]);
          } else if (recordPhotos[id].imagelabel === "bular") {
            this.photos.splice(2, 1, recordPhotos[id]);
          } else if (recordPhotos[id].imagelabel === "ciliary") {
            this.photos.splice(3, 1, recordPhotos[id]);
          }
        }
      }
      this.dispPhoto = this.photos[0];
      this.note = this.needUserfulData[this.currentEye].note;
      this.cillaryN = handleValue(this.needUserfulData[this.currentEye].nasalciliary);
      this.conjunctivalN = handleValue(this.needUserfulData[this.currentEye].nasalconjunctival);
      this.cillaryT = handleValue(this.needUserfulData[this.currentEye].tempciliary);
      this.conjunctivalT = handleValue(this.needUserfulData[this.currentEye].tempconjunctival);
    },
    selectItem(id) {
      this.currentid = id;
    },
    setShowInfo(mode) {
      this.showInfo = mode ? "300px" : "0px";
    },
    getMarking: function () {
      if (this.dispPhoto) {
        return this.dispPhoto.marking;
      } else {
        return undefined;
      }
    },
    update(marking) {
      this.curRecord.content[`data${this.currentEye}`]["eyeredness"].note = this.note;
      this.$bus.$emit(EVENTS.updateData, this.curRecord, "", "", () => {});
    },
    onImageFocus: function (dispid, paper) {
      this.currPaper = paper;
    },
    selectPaper: function (g, paper) {
      this.graph = g;
      this.currPaper = paper;
    },
    getProc: function () {
      if (this.dispPhoto) {
        return this.dispPhoto.imgproc;
      } else {
        return undefined;
      }
    },
    getEyeType: function () {
      if (this.dispPhoto) {
        return this.dispPhoto.eyetype;
      } else {
        return undefined;
      }
    },
    showHugeMap() {
      this.isHugeMapVisible = !this.isHugeMapVisible;
    },
    getImageURL: function (file) {
      return getImageUrl((file || {}).filename, window.server, window.token);
    },
    changeShowItem(id) {
      this.dispPhoto = this.photos[id];
    },
    handleClick() {
      let self = this;
      this.$bus.$emit(EVENTS.spreadKeyBoard, self.note, (value) => {
        self.note = value;
      });
    },
    changeNote(e) {
      // 失焦之后就将现有的文字赋值给记录并上传

      if (this.curRecord && this.curRecord.content) {
        this.curRecord.content[`data${this.currentEye}`]["eyeredness"].note = this.note;
        this.$bus.$emit(EVENTS.updateData, this.curRecord, "", "", () => {});
      }
    }
  },

  created() {},
  computed: {},
  watch: {
    currentEye: {
      handler(newType) {
        this.currentEye = newType;
        this.init(this.record);
      },
      immediate: true,
      deep: true
    },
    note: {
      handler(newVal) {
        this.curRecord.content[`data${this.currentEye}`]["eyeredness"].note = newVal;
        this.$bus.$emit(EVENTS.updateData, this.curRecord, "", "", () => {});
      },
      immediate: true
    },
    record: {
      handler(newRecord) {
        if (newRecord && newRecord.content) {
          this.init(newRecord);
        }
      },
      immediate: true,
      deep: true
    }
  }
};
</script>
<style lang="less" scoped>
.footer {
  width: 100%;
  height: 80px;
}
.border-top {
  border-top: solid rgba(gray, 0.1) 1px;
}
.nibut {
  position: relative;
}
label {
  font-size: 23px;
}
.before::after {
  content: "\00A0\00A0\00A0\00A0";
}
.input-result {
  font-size: 23px;
  width: 95%;
  padding: 4px 10px;
  border-radius: 5px;
  border: none;
  outline: none;
}
.border_Bbottom_Thin_bottom {
  margin-bottom: 200px;
}
.border_Bbottom_Thin {
  margin-bottom: 0px;
}
/deep/.el-dialog {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  margin: 0;
}
/deep/ .el-dialog__body {
  padding: 0 10px;
}
/deep/ .el-dialog__header {
  padding: 0;
}
#virtualKeyboard.ZH div.kbButton span {
  font-size: 18t !important;
}
/deep/.el-form-item__label {
  font-size: 36px;
  padding-left: 36px;
}
/deep/.el-form-item__content label {
  font-size: 34px;
  padding: 5px 0;
}
ul.ulContainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-right: 500px;
  font-size: 30px;
  ul {
    li {
      padding: 10px;
      font-size: 24px;
    }
  }
  li {
    list-style: none;
  }
  position: relative;
  top: -18px;
}
/deep/ .el-textarea__inner {
  min-height: 87px !important;
  font-size: 30px;
  line-height: inherit;
}
</style>



// WEBPACK FOOTER //
// src/dryeye/components/EyeRedness.vue